var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div ng-if=\"names\" class=\"registry-image-pull\"> <p> <i class=\"fa fa-info-circle\"></i>\n<span translate>To pull this image:</span> </p> <code ng-if=\"imagestream.status.publicDockerImageRepository\">$ sudo docker pull <span>{{imagestream.status.publicDockerImageRepository}}</span>/{{names[0]}}</code>\n<code ng-if=\"!settings.registry.host && !imagestream.status.publicDockerImageRepository\">$ sudo docker pull <span class=\"placeholder\">registry</span>/{{names[0]}}</code>\n<code ng-if=\"settings.registry.host && !imagestream.status.publicDockerImageRepository\">$ sudo docker pull <span>{{settings.registry.host}}</span>/{{names[0]}}</code> </div>";
ngModule.run(["$templateCache",function(c){c.put("registry-image-widgets/views/image-pull.html",v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./views/image-pull.html
// module id = 13
// module chunks = 0